import styled from 'styled-components';

export const IconContainer = styled.div`
    display: flex;
    height: 25px;
    width: 25px;
    align-items: center;
    justify-content: center;
    margin-left: 5px;
    opacity: 0.5;
`
